import { EventEmitter, Injectable } from '@angular/core';
import { Compare, delay, GroupBy } from 'src/app/shared/utilities';
import { CardComponent } from './poker/card/card.component';
import { HandCardsComponent } from './poker/hand-cards/hand-cards.component';
import { UserCache } from 'src/app/services/user-cache';

@Injectable({
  providedIn: 'root'
})
export class PokerService {
  deck:Deck;
  desk:Cards[] = [];
  players:Players[] = []
  gameMode:'PG'|'99' = 'PG'
  gameOver:boolean = false;
  playerWin:boolean = false;
  msg = '';
  round = 0;
  playerId:string;
  constructor() {
  }
  async startPickGhost(){
    this.msg = '';
    this.gameOver = false;
    this.playerWin = false;
    this.deck = new Deck();
    this.desk = [];
    this.deck.initial(1);
    this.deck.randomize();
    this.players = [new RealPlayers(this,UserCache.getLoginUser().Account,3),new AIPlayers(this,'1',4),new AIPlayers(this,'2',1),new AIPlayers(this,'3',2)]
    var getCardPlayer = this.players[0];
    while(this.deck.deckSize()>0){
      var c = this.deck.draw();
      //c.isOpen = true;
      getCardPlayer.getCard(null,c);
      //下面一位
      getCardPlayer = this.players[this.players.indexOf(getCardPlayer)+1]??this.players[0]
    }
    for(let p of this.players)
    {
      await this.整理(p,true);
    }
    
    setTimeout(async () => {
      this.gameOver = false;
      var actPlayer = this.players[0]
      while(!this.gameOver){
        if(actPlayer == this.players[0]){
          this.round++
        }
        console.log('輪到 '+ actPlayer.name+' 的回合')
        this.msg = '輪到 '+ actPlayer.name+' 的行動';
        await actPlayer.WaitAction();
        actPlayer = this.nextPlayer(actPlayer);
        while(actPlayer.hands.length==0){
          actPlayer = this.nextPlayer(actPlayer);
        }
        //手牌清空
        if(this.players[0].hands.length==0){
          this.gameOver = true;
          this.playerWin = true;
        }
        //只剩一個人有牌
        if(this.players.filter(x=>x.hands.length>0).length==1){
          this.gameOver = true;
        }
      }  
      requestAnimationFrame(()=>{
        this.players.forEach(x=>x.hands.forEach(y=>y.isOpen = true));
      })
    }, 0);
    
  }
  nextPlayer(p:Players){
    var ind = this.players.indexOf(p)
    var next = this.players[ind+1]??this.players[0]
    
    if(next.hands.length==0 || next.isLose){
      return this.nextPlayer(next);
    }
    return next;
  }
  async pickCard(player:Players,from:Players,card:Cards){
    if(this.gameMode=='PG'){
      if(from!= this.nextPlayer(player)){
        alert('只能從下家抽牌')
        return;
      }
      console.log(player.name+' 從 '+from.name+' 抽走 '+card.text )
      await from.moveTo(player,card);
      var d = from.throw(card);
      player.getCard(from,d);
      await delay(0);
      await this.整理(player);
      await delay(0);
      if(player instanceof RealPlayers){
        player.ActionDone(false);
      }
    }
  }
  async throwCard(player:Players,card:Cards,action:'plus'|'minus'){
    await player.moveTo(null,card)
    var c = player.throw(card);
    if(c.no==1 && c.type=='♠'){
      this.point = 0;
    }else if(c.no==11){
      this.point+= action=='plus'?10:-10;
      this.point = Math.max(0,this.point);
    }else if(c.no==12){
      this.point+= action=='plus'?20:-20;
      this.point = Math.max(0,this.point);
    }else if(c.no==13){
      this.point = 99;
    }else{
      this.point += card.no;
    }
    this.desk.push(c);
    await delay(0);
    var d = this.deck.draw();
    if(d){
      player.getCard(null,d)
    }
    
    if(player instanceof RealPlayers){
      player.ActionDone(false);
    }
  }
  get userPlayer():RealPlayers{
    return this.players[0] as RealPlayers;
  }
  checkCard(c:Cards,action:'plus'|'minus'){
    return (c.no==1&& c.type=='♠') 
    || c.no==13
    || ((this.noToPoint(c.no)* (action=='minus'?-1:1) + this.point)<=99)
  }
  noToPoint(no:number){
    if(no==11) return 10;
    if(no==12) return 20;
    if(no==13) return 0;
    return no;
  }
  async 整理(p:Players,skipAnimate:boolean = false){
    p.sort();
    //拿出一樣的 丟出道desk
    var g = GroupBy(p.hands,x=>x.no.toString());
    var g = g.filter(x=>x.items.length>=2);
    if(g.length>0){
      for(let x of g){
        if(!skipAnimate){
          await p.moveTo(null,x.items[0])
        }
        var c = p.throw(x.items[0]);
        c.isOpen = true;
        this.desk.push(c)
        await delay(0);
        if(!skipAnimate){
          await p.moveTo(null,x.items[1])
        }
        c = p.throw(x.items[1]);
        c.isOpen = true;
        this.desk.push(c)
      }
      await delay(0);
      await this.整理(p);
    }
  }

  point = 0;
  async start99(){
    this.msg = '';
    this.point = 0;
    this.gameMode = '99'
    this.gameOver = false;
    this.playerWin = false;
    this.deck = new Deck();
    this.desk = [];
    this.deck.initial(0);
    this.deck.randomize();
    this.players = [new RealPlayers(this,UserCache.getLoginUser().Account,3),new AIPlayers(this,'1',4),new AIPlayers(this,'2',1),new AIPlayers(this,'3',2)]
    var getCardPlayer = this.players[0];
    var cnt = 0
    while(cnt<5){
      var c = this.deck.draw();
      getCardPlayer.getCard(null,c);
      //下面一位
      getCardPlayer = this.players[this.players.indexOf(getCardPlayer)+1]??this.players[0]
      if(getCardPlayer == this.players[0]){
        cnt++
      }
    }
    for(let p of this.players)
    {
      p.sort()
    }
    
    setTimeout(async () => {
      this.gameOver = false;
      var actPlayer = this.players[0]
      while(!this.gameOver){
        if(actPlayer == this.players[0]){
          this.round++
        }
        console.log('輪到 '+ actPlayer.name+' 的回合')
        this.msg = '輪到 '+ actPlayer.name+' 的行動';
        var giveUp = await actPlayer.WaitAction();
        if(giveUp){
          //玩家放棄
          if(actPlayer == this.players[0]){
            this.gameOver = true;  
            break;
          }
          actPlayer.isLose = true;
          actPlayer.hands.forEach(x=>x.isOpen=true)
        }
        //只剩一個人沒輸
        if(this.players.filter(x=>!x.isLose).length==1){
          this.gameOver = true;
          this.playerWin = true;
          break;
        }
        actPlayer = this.nextPlayer(actPlayer);
        if(this.deck.deckSize()==0){
          this.deck.cards = [...this.deck.cards,...this.desk]
          this.desk = [];
          this.deck.randomize();
        }
        // while(actPlayer.hands.length==0){
        //   actPlayer = this.nextPlayer(actPlayer);
        // }
      }  
      requestAnimationFrame(()=>{
        this.players.forEach(x=>x.hands.forEach(y=>y.isOpen = true));
      })
    }, 0);
    
  }
}

export declare type symbols = '♠'|'♡'|'♢'|'♣'|'🃟'
export declare type numbers = 'A'|'2'|'3'|'4'|'5'|'6'|'7'|'8'|'9'|'10'|'J'|'Q'|'K'

export class Cards{
  text:string;
  isOpen:boolean=false;
  comp:CardComponent;
  constructor(public no:number, public type:symbols) {
    switch(type){
      case '🃟':
        this.text = '🃟'
        break;
      case '♡':
        var s = ['🂱','🂲','🂳','🂴','🂵','🂶','🂷','🂸','🂹','🂺','🂻','🂽','🂾']
        this.text  =s[no-1];
        break;
      case '♠':
        var s = ['🂡','🂢','🂣','🂤','🂥','🂦','🂧','🂨','🂩','🂪','🂫','🂭','🂮']
        this.text  =s[no-1];
        break;
      case '♢':
        var s = ['🃁','🃂','🃃','🃄','🃅','🃆','🃇','🃈','🃉','🃊','🃋','🃍','🃎']
        this.text  =s[no-1];
        break;
      case '♣':
        var s = ['🃑','🃒','🃓','🃔','🃕','🃖','🃗','🃘','🃙','🃚','🃛','🃝','🃞']
        this.text  =s[no-1];
        break;
    }
  }
}

export abstract class Players{
  
  hands:Cards[];
  handComp:HandCardsComponent;
  isLose:boolean = false;
  msg:string;
  constructor(protected GM:PokerService, public name:string,public seat:number) {
    this.hands = []
  }
  getCard(player:Players, card: Cards) {
    this.hands.push(card)
  }
  
  throw(card:Cards){
    var ind = this.hands.indexOf(card);
    var card = this.hands.splice(ind,1)[0]
    //card.isOpen =true;
    return card
  }
  sort(){
    this.hands.sort((a,b)=>Compare(a.no,b.no)||Compare(a.type,b.type))
  }
  randomize(){
    for (let i = this.hands.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [this.hands[i], this.hands[j]] = [this.hands[j], this.hands[i]];
    }
  }
  async moveTo(player:Players,card:Cards){
    await this.handComp?.moveTo(player,card)
  }
  dispose(){}
  abstract get WaitingAction():ActionState;
  abstract WaitAction():Promise<boolean>;
}
declare type ActionState ='Waiting'|'Running'|'Done'
export class AIPlayers extends Players{
  constructor(protected GM:PokerService, public name:string,public seat:number) {
    super(GM,name,seat);
  }
  _waitAction = false;
  get WaitingAction(): ActionState {
    return this._waitAction?'Waiting':'Done';
  }
  async WaitAction(): Promise<boolean> {
    if(this.GM.gameMode=='PG'){
      this._waitAction = true;
      var nextPlayer = this.GM.nextPlayer(this);
      var ind = Math.floor(Math.random()*nextPlayer.hands.length)
      var c = nextPlayer.hands[ind];
      await this.GM.pickCard(this,nextPlayer,c);
      this.randomize();
      this._waitAction = false;
      return false;
    }
    if(this.GM.gameMode=='99'){
      var point = this.GM.point;
      var avaliable = this.hands.filter(x=>{
        return (x.no==1&& x.type=='♠') 
            || (x.no>10)
            || (this.GM.noToPoint(x.no)+point<=99)
      })
      if(avaliable.length==0){
        this.msg = '我沒牌可出了'
        return true;
      }
      var ind = Math.floor(Math.random()*avaliable.length)
      var card = avaliable[ind];
      var act:'plus'|'minus' = Math.random()>0.5?'plus':'minus';
      if(card.no>10 && (point+this.GM.noToPoint(card.no))>99){
        act = 'minus'
      }
      await this.GM.throwCard(this,card,act)
      return false;
    }
  }
  
  getCard(player:Players, card: Cards) {
    super.getCard(player,card);
    card.isOpen = false;
  }
}
export class RealPlayers extends Players{
  constructor(protected GM:PokerService, public name:string,public seat:number) {
    super(GM,name,seat);
  }
  getCard(player:Players,card: Cards): void {
    super.getCard(player,card);
    card.isOpen = true;
  }
  _actionPromise:(a:boolean)=>void
  _actionRunning=false;
  ActionDone(giveUp:boolean){
    this._actionPromise(giveUp);
    this._actionPromise = null;
    this._actionRunning = false;
  }
  RunningAction(){
    this._actionRunning = true;
  }
  get WaitingAction():ActionState{
    return this._actionPromise!=null?this._actionRunning?'Running':'Waiting':'Done';
  }
  async WaitAction(): Promise<boolean> {
    this._actionRunning = false;
    return new Promise<boolean>((rs,rj)=>this._actionPromise = rs);
  }
}
export class Deck{
  cards:Cards[];
  /**
   *
   */
  constructor() {
    this.cards = []
    var symbols:symbols[] = ['♠','♡','♢','♣'];
    symbols.forEach(s=>{
      for(let n=1;n<=13;n++){
        this.cards.push(new Cards(n,s));
      }
    })
  }
  initial(withGhost:number){
    this.cards = []
    var symbols:symbols[] = ['♠','♡','♢','♣'];
    
    for(let n=1;n<=13;n++){
      symbols.forEach(s=>{
        this.cards.push(new Cards(n,s));
      })
    }
    for(let g=0;g<withGhost;g++){
      this.cards.push(new Cards(g*-1,'🃟'));
    }
  }
  randomize(){
    //Fisher–Yates 洗牌法（無偏差，真隨機，所有排列等機率）
    //牌洗不乾淨還是得靠AI
    for (let i = this.cards.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [this.cards[i], this.cards[j]] = [this.cards[j], this.cards[i]];
    }
    // //切牌式洗牌
    // for(let i=0;i<30;i++){
    //   var ind = Math.max(1, Math.min(this.cards.length-1,Math.random()*this.cards.length));
    //   // s:下方切出來的, cards:上方的
    //   var s = this.cards.splice(ind);
    //   //交換
    //   this.cards = [...s,...this.cards];
    // }
    // // 啪啦啪啦洗牌法
    // for(let i=0;i<1;i++){
    //   var s1 = this.cards;
    //   var s2 = this.cards.splice(this.cards.length/2);
    //   //由下往上
    //   s1 = s1.reverse();
    //   s2 = s2.reverse()
    //   s = [];
    //   var times=Math.min(s1.length,s2.length);
    //   for(let i=0; i<times;i++){
    //     //上疊拿一張
    //     s.push(s1.splice(0,1)[0])
    //     //下疊拿一張
    //     s.push(s2.splice(0,1)[0])
    //   }
    //   // 沒拿完的往下堆
    //   s=[...s,...s1,...s2].reverse()
    //   this.cards = s;
    // }
    this.cards.forEach(x=>{
      console.log(x.type+x.no)
    })
  }
  /** 抽卡 */
  draw(){
    if(this.cards.length==0){
      return null;
    }
    var card = this.cards.splice(0,1);
    return card[0];
  }
  deckSize(){
    return this.cards.length;
  }
}
class RemotePlayerInfo{
  Id:string;
  Name:string;
  hands:Cards[] = []
}